import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront'
import { EbContactCardComponent } from './components/contact-card/eb-contact-card.component'
import { EbPartnerSlotLayoutHandler } from './eb-partner-slot-layout-handler'

@NgModule({
  imports: [CommonModule, I18nModule, UrlModule],
  providers: [
    provideConfig({
      cmsComponents: {
        ContactCardComponent: {
          component: EbContactCardComponent
        }
      }
    }),
    EbPartnerSlotLayoutHandler,
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: EbPartnerSlotLayoutHandler,
      multi: true
    }
  ],
  declarations: [EbContactCardComponent]
})
export class EbPartnersModule {}
